<template>
    <div class="main-body">

        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: "MainBody"
    }
</script>

<style lang="scss" scoped>

    /* 主体样式 */
    .main-body{
        background-color: #ffffff;
        padding: 20px;
        border: 1px solid #ebeef5;
        color: #303133;
        transition: .3s;
        border-radius: 4px;

    }

</style>